import request from './request.js'

const BASE_URL = 'https://tsh.wangyyapp.com/'
// const BASE_URL = 'http://127.0.0.1:8080/'

// 微信jssdk
const JsSdkSign = async (params) => {
  return await request.post(BASE_URL + 'api/userAccount/JsSdkSign', params)
}

// 获取scheme
const getScheme = async (params) => {
  return await request.postJson(BASE_URL + 'wxapp/scheme', params)
}

const getHandling = async (params) => {
  return await request.get(BASE_URL + 'api/home/getHandling', params)
}

// 获取码订单信息
const getCodeOrderInfo = async (params) => {
  return await request.post(BASE_URL + 'api/taskPublishing/getCodeOrderInfo', params)
}

// 获取码订单信息
const tradeUserCheck = async (params) => {
  return await request.get(BASE_URL + 'api/taskPublishing/tradeUserCheck', params)
}

// 获取活动信息
const getActivity = async (params) => {
  return await request.get(BASE_URL + 'api/taskPublishing/getActivity', params)
}

// 创建线下任务
const addOfflineTaskSubmit = async (params) => {
  return await request.get(BASE_URL + 'api/taskPublishing/addOfflineTaskSubmit', params)
}

// 获取任务详情
const getTaskSubmitInfo = async (params) => {
  return await request.get(BASE_URL + 'api/taskPublishing/getTaskSubmitInfo', params)
}

// 支付
const offlineSubmitPay = async (params) => {
  return await request.post(BASE_URL + 'api/pay/offlineSubmitPay', params)
}

const fileUpload = async (params) => {
  return await request.postImg(BASE_URL + 'api/user/upload', params)
}

const uploadOfflineTaskSubmit = async (params) => {
  return await request.post(BASE_URL + 'api/taskPublishing/uploadOfflineTaskSubmit', params)
}

const downloadFileBase64 = async (url) => {
  return await request.getBlob(url)
}

export default {
  JsSdkSign,
  getScheme,
  getCodeOrderInfo,
  getHandling,
  tradeUserCheck,
  getActivity,
  addOfflineTaskSubmit,
  getTaskSubmitInfo,
  offlineSubmitPay,
  fileUpload,
  uploadOfflineTaskSubmit,
  downloadFileBase64
}
